<p-table #TaskList [value]="tasks" sortMode="multiple" 
  [loading]="loading" 
  [paginator]="true" 
  [rows]="rowlimit"
  [rowsPerPageOptions]="[10,25,50,100]"
  [globalFilterFields]="['EventNameWithUnitLabel']">
  <ng-template pTemplate="caption">
    <div class="search-container">        
        <i class="pi pi-search filterInput"></i>
        <i class="fas fa-times clear-search" (click)="clearSearchBox(TaskList)"></i>
        <input type="text" pInputText size="50" placeholder="Filter By: Task Name" (input)="TaskList.filterGlobal($event.target.value, 'contains')" [(ngModel)]="searchText" style="width:auto">
    </div>
  </ng-template>
  <ng-template pTemplate="header" let-columns>
    <tr>
      <th [pSortableColumn]="'EventName'">Task Name
        <p-sortIcon [field]="'EventName'"></p-sortIcon>
      </th>
      <th [pSortableColumn]="'AssignedRoleName'">Role
        <p-sortIcon [field]="'AssignedRoleName'"></p-sortIcon>
      </th>
      <th [pSortableColumn]="'AssignedPersonFirstName'">Person
        <p-sortIcon [field]="'AssignedPersonFirstName'"></p-sortIcon>
      </th>
      <th [pSortableColumn]="'CloseOperatorFirstName'">Completed By
        <p-sortIcon [field]="'CloseOperatorFirstName'"></p-sortIcon>
      </th>
      <th [pSortableColumn]="'OpenDate'">Open Date
        <p-sortIcon [field]="'OpenDate'"></p-sortIcon>
      </th>
      <th [pSortableColumn]="'CloseDate'">Due/Completed
        <p-sortIcon [field]="'CloseDate'"></p-sortIcon>
      </th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-tasks>
    <tr>
      <td *ngIf="!canAccessTask(tasks.TaskStatusId, tasks.CanOperatorCompleteTask)">
          {{tasks.EventName}} {{extendedEventName(tasks?.UnitLabel,tasks?.OtherEventTypeGroup,tasks?.OtherEventTypeLabel,tasks?.SequenceNumber)}}
      </td>
      <td *ngIf="canAccessTask(tasks.TaskStatusId, tasks.CanOperatorCompleteTask)">
        <a href="{{_taskListSvc.getTaskViewUri(tasks.EventLocation,tasks.PropertyId, tasks.TaskInstanceId, tasks.ParentEventTrackingId)}}">
          {{tasks.EventName}} {{extendedEventName(tasks?.UnitLabel,tasks?.OtherEventTypeGroup,tasks?.OtherEventTypeLabel,tasks?.SequenceNumber)}}
        </a>
      </td>
    <td>{{tasks.AssignedRoleName}}</td>
    <td>{{tasks.AssignedPersonFirstName.substring(0,1)}}. {{tasks.AssignedPersonLastName}}</td>
    <td>{{completedBy(tasks?.CloseOperatorFirstName,tasks?.CloseOperatorLastName)}}</td>
    <td>{{tasks?.OpenDate | dateTimeFormat:'MM/dd/yyyy h:mm'}}</td>
    <td [class]="getStatusClass(tasks.TaskStatusId)">
      {{tasks?.DueDate | dateTimeFormat:'MM/dd/yyyy h:mm'}} ({{tasks?.DaysToClose}}) {{getDueCompleteSuffix(tasks)}}
      </td>
    </tr>
  </ng-template>
  <ng-template pTemplate="paginatorright" let-state>
    Showing {{state.first}} to {{state.first+state.rows}} of {{state.totalRecords}} entries
  </ng-template>
</p-table>
